import { Button, Popconfirm, Space } from "antd";
import { DeleteFilled, EditFilled } from "@ant-design/icons";

const propsColumnsExtraTime = () => {
	return {
		size: "large",
		scroll: { x: "100vh", y: null },
		bordered: true,
	};
};

const columnsType = (editAction, deleteAction, filter = { isSuperAdmin: false }) => {
	return [
		{
			title: "Horas",
			dataIndex: "hours",
			key: "hours",
			// render: (text) => <span>{text ? <CheckCircleTwoTone twoToneColor="green" /> : <CloseCircleTwoTone twoToneColor="red" />}</span>,
		},
		{
			title: "Área",
			dataIndex: "area",
			key: "area",
			sorter: (a, b) => {
				if (a.email < b.email) {
					return -1;
				}
				if (a.email > b.email) {
					return 1;
				}
				return 0;
			},
			render: (text) => <span style={{ textTransform: "lowercase" }}>{text}</span>,
		},
		{
			title: "Desarrollador",
			dataIndex: "developer",
			key: "developer",
			sorter: (a, b) => {
				if (a.rol < b.rol) {
					return -1;
				}
				if (a.rol > b.rol) {
					return 1;
				}
				return 0;
			},
			render: (text) => <span style={{ textTransform: "lowercase" }}>{text}</span>,
		},
		{
			title: "Periodo de prueba",
			dataIndex: "periodOfWork",
			key: "periodOfWork",
		},
		{
			title: "Comentario",
			dataIndex: "comment",
			key: "comment",
		},
		{
			title: "Fecha",
			dataIndex: "createdAt",
			key: "createdAt",
		},
		{
			title: "Action",
			key: "action",
			render: (_, record) => (
				<Space size="middle">
					{filter.isSuperAdmin && (
						<>
							<Button
								type="text"
								icon={<EditFilled />}
								onClick={() => {
									editAction(record);
								}}
							/>
							<Popconfirm title="¿Seguro eliminar?" onConfirm={() => deleteAction(record.key)}>
								<Button type="text" icon={<DeleteFilled />} />
							</Popconfirm>
						</>
					)}
				</Space>
			),
		},
	];
};

export const columnsExtraTime = (editAction, deleteAction, filter = { isSuperAdmin: false }) => {
	const columns = columnsType(editAction, deleteAction, filter);
	const props = propsColumnsExtraTime();
	return {
		columns,
		props,
	};
};
